import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step282435Meta extends BaseModel {
  /**
   * @var {string}
   */
  calculationExplanation;

  /**
   * @var {string}
   */
  chequeRecipient;

  /**
   * @var {boolean}
   */
  requiresProbate;

  constructor(model = {}) {
    super();

    this.calculationExplanation = model.calculationExplanation;
    this.chequeRecipient = model.chequeRecipient;
    this.requiresProbate = model.requiresProbate;
  }
}
